const LAYOUT_TYPE = {
  SECTION: "Section",
  ROW: "Row",
  COLUMN: "Column"
};

export { LAYOUT_TYPE };
